import { IResultDisplay } from "../../../../Interfaces";
import React, { useEffect, useState } from "react";
import "./ExpertiseList.css";

const ExpertiseList = ({
  resultData,
  setExpertiseData,
  setIndexExpertise,
  nameJob,
}: {
  resultData: IResultDisplay[];
  setExpertiseData: React.Dispatch<React.SetStateAction<IResultDisplay | null>>;
  setIndexExpertise: React.Dispatch<React.SetStateAction<number>>;
  nameJob: string | undefined;
}) => {
  const [selectExpertise, setSelectExpertise] = useState(0);
  const [job, setJob] = useState<string | undefined>("");

  const resetToFirstExpertise = (jobName: string | undefined) => {
    return setJob(jobName);
  };

  const checkForSelection = (indexToCompare: number) => {
    return selectExpertise === indexToCompare && !false ? true : false;
  };

  useEffect(() => {
    if (job !== nameJob) {
      resetToFirstExpertise(nameJob);
    }
    // eslint-disable-next-line
  }, [nameJob]);

  return (
    <div className="resultExpertiseList">
      <p className="resultExpertiseTitle">DOMAINE D’EXPERTISE</p>
      <ul className="resultExpertiseUnorderList">
        {resultData.map((domain: IResultDisplay, index: number) => {
          return (
            <div
              key={domain.name}
              className="resultExpertiseUnorderItem"
              onClick={() => {
                setExpertiseData(domain);
                setSelectExpertise(index);
                setIndexExpertise(index);
              }}
              style={{
                background: checkForSelection(index) ? "#bfdaec" : "",
                color: checkForSelection(index) ? "#4a8cca" : "",
                height: checkForSelection(index) ? "100%" : "",
              }}
            >
              <p className="emojiResult">🏗</p>
              <li className="resultExpertiseName">{domain.name}</li>
            </div>
          );
        })}
      </ul>
    </div>
  );
};

export default ExpertiseList;
